import React from 'react'

function Value({ src, alt, heading }) {
  return (
    <div className='bg-orange h-[150px] md:h-[200px] lg:h-[190px] w-full md:w-1/3 lg:w-1/4 flex flex-col items-center justify-center gap-3 rounded-md'>
        <div className='h-1/2 w-1/5 md:w-1/3 bg-white flex items-center justify-center rounded-full'>
            <img className='h-[40px] md:h-[70px] w-[40px] md:w-[70px]' src={src} alt={alt} />
        </div>
        <h1 className='text-3xl text-white font-roboto font-light md:font-medium'>{heading}</h1>
    </div>
  )
}

export default Value